import React from "react";
import { ISVG } from "./interface";

const SVG: React.FC<ISVG> = ({
  style = {},
  fill = "none",
  width = 24,
  height = 30,
  className = "",
  viewBox = "0 0 24 30",
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    fill={fill}
    viewBox={viewBox}
    className={`svg-icon ${className || ""}`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group">
      <path
        id="Vector"
        d="M11.357 20.4502L10.5767 19.6698L9.32886 20.9176L11.357 22.9458L14.671 19.6319L13.4232 18.384L11.357 20.4502Z"
        fill="var(--tlx-cta-primary-default)"
      />
      <path
        id="Vector_2"
        d="M16.7771 0H0.529297V30H23.4705V6.69335L16.7771 0ZM17.294 3.01253L20.4579 6.17647H17.294V3.01253ZM2.294 28.2353V1.76471H15.5293V7.94118H21.7058V28.2353H2.294Z"
        fill="var(--tlx-cta-primary-default)"
        stroke="var(--tlx-stroke-border-default)"
        strokeWidth="0.5"
      />
      <path
        id="Vector_3"
        d="M4.05859 5.29419H5.45859V8.8236H4.05859V5.29419Z"
        fill="var(--tlx-cta-primary-default)"
      />
      <path
        id="Vector_4"
        d="M7.58813 3.5293H8.98813V8.82341H7.58813V3.5293Z"
        fill="var(--tlx-cta-primary-default)"
      />
      <path
        id="Vector_5"
        d="M11.1174 5.29419H12.5174V8.8236H11.1174V5.29419Z"
        fill="var(--tlx-cta-primary-default)"
      />
      <path
        id="Vector_6"
        d="M12 14.1177C8.59419 14.1177 5.82349 16.8884 5.82349 20.2941C6.13396 28.4769 17.8672 28.4746 18.1764 
        20.2941C18.1764 16.8884 15.4057 14.1177 12 14.1177ZM12 24.7059C9.56725 24.7059 7.58819 22.7268 7.58819 
        20.2941C7.80996 14.4494 16.1908 14.451 16.4117 20.2942C16.4117 22.7268 14.4326 24.7059 12 24.7059Z"
        fill="var(--tlx-cta-primary-default)"
        stroke="var(--tlx-stroke-border-default)"
        strokeWidth="0.6"
      />
      <path
        id="Vector_7"
        d="M4.05859 10.5881H18.1762V11.5881H4.05859V10.5881Z"
        fill="var(--tlx-cta-primary-default)"
      />
    </g>
  </svg>
);

export default SVG;
